module.exports = __webpack_public_path__ + "static/media/together.0a7d3317.png";